import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DdosModalComponent } from './ddos-modal.component';

@NgModule({
  declarations: [DdosModalComponent],
  imports: [CommonModule],
  exports: [DdosModalComponent]
})
export class DdosModalModule {}
